import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { CollectionInsightProcessModalCtrl } from './collection.insight.process.modal.ctrl';
import { CSS, Style } from './collection.insight.process.modal.style';

addStyles(Style);

export class CollectionInsightProcessModal extends ModalFormComponent {
	private ctrl: CollectionInsightProcessModalCtrl;

	constructor(ctx: ModalFormComponentCtx, collections: CollectionSummaryJSONObject[]) {
		super(ctx);
		this.ctrl = new CollectionInsightProcessModalCtrl(collections);
	}

	get nodes(): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.content }, [
				m('p', Translate(T.COLLECTION_INSIGHT_PROCESS_CONFIRM, this.ctrl.collections.length)),
			]),
		]);
	}

	override async submit() {
		await this.ctrl.insightProcessCollections();
	}
}
